module.exports = __webpack_public_path__ + "img/curve-header.f23a54bd.png";